import { lazy } from "react";
import ErrorBoundary from "@/hoc/ErrorBoundary/ErrorBoundary.jsx";

const Disclaimer = lazy(() => import("./Disclaimer"));

export const disclaimerRoute = {
  path: "disclaimer",
  element: <Disclaimer />,
  errorElement: <ErrorBoundary />
};
